import { connect } from 'react-redux';
import AppDidUpdate from './appDidUpdate';
import setButtonListWidth from '../../../shared/actions/setButtonListWidth';
import setListContainerWidth from '../../../shared/actions/setListContainerWidth';
import { openPanel } from '../../../shared/actions/sidebar';
import { panelGroup, panelType } from '../../../shared/constants';

const mapStateToProps = state => ({
  scale: state.scale,
  fitToWidth: state.stayFitToWidth,
  isOutlineOpen: state.sidebar,
  clientSize: state.clientSize,
  recommendations: state.recommendations,
  citingArticles: state.citingArticles,
  autoOpenArticleInfo: state.viewConfig.viewerFeature.autoOpenArticleInfo,
});

const mapDispatchToProps = dispatch => ({
  setButtonListWidth: () => dispatch(setButtonListWidth()),
  setListContainerWidth: () => dispatch(setListContainerWidth()),
  openArticleInfoPanel: () => dispatch(openPanel(
    panelGroup.connections,
    panelType.articleInfo,
    { userInitiatedUpdate: false },
  )),
});

export default connect(mapStateToProps, mapDispatchToProps)(AppDidUpdate);
